/**
 * Where Stripe returns a merchant after they pay one month's commission.
 *
 * Public on purpose: the merchant is not a Homecrowd user. They opened a link
 * staff copied from Merchant Pay, so this only confirms the payment.
 */

const page = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px',
  backgroundColor: '#f9fafb',
  fontFamily: '"Baikal Book", -apple-system, BlinkMacSystemFont, sans-serif',
};

const card = {
  width: '100%',
  maxWidth: '520px',
  backgroundColor: 'white',
  border: '1px solid #e5e7eb',
  borderRadius: '12px',
  padding: '40px',
  textAlign: 'center',
};

const MerchantCommissionPaid = () => (
  <div style={page}>
    <div style={card}>
      <div
        style={{
          width: '56px',
          height: '56px',
          margin: '0 auto 24px',
          borderRadius: '50%',
          backgroundColor: '#dcfce7',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M4 12.5l5 5L20 6.5"
            stroke="#16a34a"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <h1 style={{ fontSize: '22px', fontWeight: 600, color: '#111827', margin: '0 0 12px' }}>
        Thanks — your payment went through
      </h1>

      <p style={{ fontSize: '15px', lineHeight: 1.6, color: '#4b5563', margin: '0 0 20px' }}>
        Stripe, our payment processor, has the card payment for this month's Homecrowd commission.
      </p>

      <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>
        You can close this window. Questions? Email{' '}
        <a href="mailto:support@gethomecrowd.com" style={{ color: '#0369a1' }}>
          support@gethomecrowd.com
        </a>
        .
      </p>
    </div>
  </div>
);

export default MerchantCommissionPaid;
